import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=10906298&"
import script from "./notifications.vue?vue&type=script&lang=ts&"
export * from "./notifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports